import React from 'react';

const UserCard = ({ user, isExpanded, onToggle, assignProjectToUser, updateUserData }) => (
    <div className={`user-card ${isExpanded ? 'expanded' : ''}`}>
        <div className="user-header" onClick={() => onToggle(user.email)}>
            <h3>{user.email}</h3>
            <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
        </div>
        {isExpanded && (
            <div className="user-details">
                <button
                    className="add-button"
                    onClick={() => {
                        const newProjectLabel = prompt("Enter new project label:");
                        const newProjectCode = prompt("Enter new project code:");
                        const newRole = prompt("Enter role for the new project:");
                        if (newProjectLabel && newProjectCode && newRole) {
                            assignProjectToUser(user.email, {
                                project: newProjectCode,
                                project_label: newProjectLabel,
                                roles: {
                                    [newRole]: { actions: [], pages: [] }
                                }
                            });
                        }
                    }}
                >
                    + Assign New Project
                </button>
                {user.projects?.map((project, projectIndex) => (
                    <div key={projectIndex} className="project-section">
                        <div className="project-header">
                            <h4>{project.project_label}  {project.project} role: {project.role}</h4>
                            <button
                                className="add-button"
                                onClick={() => {
                                    const newRole = prompt("Enter new role name:");
                                    if (newRole && !project.roles[newRole]) {
                                        updateUserData(
                                            user.email,
                                            projectIndex,
                                            newRole,
                                            'newRole'
                                        );
                                    } else if (project.roles[newRole]) {
                                        alert("Role already exists!");
                                    }
                                }}
                            >
                                + Add Role
                            </button>
                        </div>
                        {Object.entries(project.roles || {}).map(([roleKey, roleData]) => (
                            <div key={roleKey} className="role-section">
                                <h5>Role: {roleKey}</h5>
                                <button
                                    className="edit-button"
                                    onClick={() => {
                                        const newRoleName = prompt("Enter new role name:", roleKey);
                                        if (newRoleName && newRoleName !== roleKey) {
                                            const updatedRoles = { ...project.roles };
                                            updatedRoles[newRoleName] = updatedRoles[roleKey];
                                            delete updatedRoles[roleKey];
                                            updateUserData(
                                                user.email,
                                                projectIndex,
                                                newRoleName,
                                                'roles',
                                                updatedRoles
                                            );
                                        }
                                    }}
                                >
                                    Edit Role Name
                                </button>
                                <div className="section-header">
                                    <h6>Actions</h6>
                                    <button
                                        className="add-button"
                                        onClick={() => {
                                            const newAction = prompt("Enter new action (e.g., GET /path):");
                                            if (newAction) {
                                                updateUserData(
                                                    user.email,
                                                    projectIndex,
                                                    roleKey,
                                                    'actions',
                                                    [...(roleData.actions || []), newAction]
                                                );
                                            }
                                        }}
                                    >
                                        + Add Action
                                    </button>
                                </div>
                                <div className="actions-grid">
                                    {roleData.actions?.map((action, actionIdx) => (
                                        <div key={actionIdx} className="action-chip">
                                            {action.split(' ')[0]}
                                            <span className="action-path">
                                                {action.split(' ')[1]}
                                            </span>
                                            <button
                                                className="delete-button"
                                                onClick={() => {
                                                    const newActions = roleData.actions.filter((_, idx) => idx !== actionIdx);
                                                    updateUserData(
                                                        user.email,
                                                        projectIndex,
                                                        roleKey,
                                                        'actions',
                                                        newActions
                                                    );
                                                }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                <div className="section-header">
                                    <h6>Pages</h6>
                                    <button
                                        className="add-button"
                                        onClick={() => {
                                            const newPage = prompt("Enter new page path:");
                                            if (newPage) {
                                                updateUserData(
                                                    user.email,
                                                    projectIndex,
                                                    roleKey,
                                                    'pages',
                                                    [...(roleData.pages || []), newPage]
                                                );
                                            }
                                        }}
                                    >
                                        + Add Page
                                    </button>
                                </div>
                                <div className="pages-grid">
                                    {roleData.pages?.map((page, pageIdx) => (
                                        <div key={pageIdx} className="page-chip">
                                            {page}
                                            <button
                                                className="delete-button"
                                                onClick={() => {
                                                    const newPages = roleData.pages.filter((_, idx) => idx !== pageIdx);
                                                    updateUserData(
                                                        user.email,
                                                        projectIndex,
                                                        roleKey,
                                                        'pages',
                                                        newPages
                                                    );
                                                }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        )}
    </div>
);

export default UserCard;